const dateFormatter = new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
});

const timeFormatter = new Intl.DateTimeFormat(undefined, {
    hour: "numeric",
    minute: "2-digit",
});

export const formatDuration = (
    secondsValue: number | string | null | undefined,
) => {
    const seconds = Math.max(0, Math.round(Number(secondsValue) || 0));
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    if (hours) return `${hours} hr ${minutes} min`;
    if (minutes)
        return `${minutes} min${remainingSeconds ? ` ${remainingSeconds} sec` : ""}`;
    return `${remainingSeconds} sec`;
};

export const formatLocalDateTime = (value?: string) => {
    const date = new Date(value || "");
    if (Number.isNaN(date.getTime()))
        return { date: "Unknown date", time: "—" };
    return {
        date: dateFormatter.format(date),
        time: timeFormatter.format(date),
    };
};

export const formatPatientDateTime = (
    value?: string,
    offsetSeconds?: number | null,
) => {
    const date = new Date(value || "");
    if (Number.isNaN(date.getTime()))
        return { date: "Unknown date", time: "—" };
    if (
        offsetSeconds === null ||
        offsetSeconds === undefined ||
        !Number.isFinite(Number(offsetSeconds))
    ) {
        return formatLocalDateTime(value);
    }
    const adjusted = new Date(date.getTime() + Number(offsetSeconds) * 1000);
    const options = { timeZone: "UTC" };
    return {
        date: adjusted.toLocaleDateString(undefined, {
            year: "numeric",
            month: "short",
            day: "numeric",
            ...options,
        }),
        time: adjusted.toLocaleTimeString(undefined, {
            hour: "numeric",
            minute: "2-digit",
            ...options,
        }),
    };
};

export const patientDateKey = (
    value?: string,
    offsetSeconds?: number | null,
) => {
    const date = new Date(value || "");
    if (Number.isNaN(date.getTime())) return "";
    const adjusted = new Date(
        date.getTime() + (Number(offsetSeconds) || 0) * 1000,
    );
    return adjusted.toISOString().slice(0, 10);
};
